import template from './direction-navigator.html'

const DirectionNavigatorComponent = {
    bindings: {
        displayValue: '<',
        isClickLeft: '<',
        isClickRight: '<',
        onClickLeft: '&',
        onClickRight: '&'
    },
    template,
};

export default DirectionNavigatorComponent;



// WEBPACK FOOTER //
// ./app/common/direction-navigator/direction-navigator-component.js